<template>

  <vs-select v-model="selectedMinute" width="55px" :disabled="disabled" placeholder="">
    <vs-select-item :text="''" v-show="selectedMinute === undefined" />
    <vs-select-item v-for="(item, index) in options" :key="index" :value="item" :text="item.text" />
  </vs-select>

</template>

<script>
import * as _ from "lodash";

export default {
  props: {
    value: {
      type: Number,
    },
    fromMinute: {
      type: Number,
      validator: (value) => {
        return _.isInteger(value) && value >= 0 && value <= 59;
      },
      default: 0,
    },
    toMinute: {
      type: Number,
      validator: (value) => {
        return _.isInteger(value) && value >= 0 && value <= 59;
      },
      default: 23,
    },
    minuteInterval: {
      type: Number,
      validator: (value) => {
        return _.isInteger(value) && value >= 0 && value <= 30 && value%15 === 0;
      },
      default: 15,
    },
    disabled :{
      type: Boolean
    }
  },
  data() {
    return {
      options: [],
      selectedMinuteItem: undefined,
    };
  },
  computed: {
    selectedMinute: {
      get() {
        if(this.value !== null && this.value !== undefined) {
          const item = this.options.find(item => item.value === this.value);

          return item;
        }

        return undefined;
      },
      set(item) {


        this.$emit('input', item ? item.value : undefined);
      }
    }
  },
  mounted() {
    this.createOptions();
  },
  methods: {
    createOptions() {
      for(let i = this.fromMinute; i<=this.toMinute; i = i + this.minuteInterval) {
        this.options.push({
          value: i,
          text: _.padStart(i, 2, '0')
        });
      }
    },
    handleChange(value) {
    }
  },
};
</script>

<style scoped>
.test {
  width:50px;
}
</style>
